import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mzic-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mzic-alert.component.html',
  styleUrls: ['./mzic-alert.component.scss'],
})
export class MzicAlertComponent {
  @Input({required: true}) message!: string;
  @Input({required: true}) variant!: string;

}
